<template>
  <router-view></router-view>
</template>

<script>
import Vue from 'vue'
import VueHead from 'vue-head'

// Load FacebookSDK
var loadSdk = function (d, s, id) {
  var js = d.getElementsByTagName(s)[0]
  var fjs = d.getElementsByTagName(s)[0]
  if (d.getElementById(id)) return
  js = d.createElement(s); js.id = id
  js.src = 'https://connect.facebook.net/en_US/sdk.js'
  fjs.parentNode.insertBefore(js, fjs)
}

loadSdk(document, 'script', 'facebook-jssdk')
window.fbAsyncInit = function () {
  window.FB.init({
    appId: process.env.NODE_ENV === 'development' ? '1011819239015324' : '1554981731355750',
    autoLogAppEvents: true,
    xfbml: true,
    version: 'v3.2'
  })
}

Vue.use(VueHead)

export default {
  name: 'app'
}
</script>

<style lang="scss">
  @import "./foundation/scss/Reset";
  @import "./foundation/scss/Base";
</style>



// WEBPACK FOOTER //
// src/App.vue